<template lang="pug">
.leftMenu
  b-list-group
    b-list-group-item(
      v-for="menuItem in menuItems" 
      :key="menuItem.key" 
      v-show="menuItem.show" 
      ref="listGroupItem"
      href="#" 
      :class="['menuLevel' + menuItem.level, menuItem.aditionalClass]"
      @click="clickMenu(menuItem)") 
      template(v-if="menuItem.path")
        i.menuIcon(:class="[ (menuItem.subMenuShow && menuItem.iconOpen) ? menuItem.iconOpen : menuItem.icon ]")
        a(v-if="isSamePath(menuItem.path)" @click="$emit('refresh')")
          span.menuText {{ $t(menuItem.text) }}
        router-link(v-else :to="menuItem.path")
          span.menuText {{ $t(menuItem.text) }}
      template(v-else)
        i.menuIcon(:class="[ (menuItem.subMenuShow && menuItem.iconOpen) ? menuItem.iconOpen : menuItem.icon ]")
        span.menuText {{ $t(menuItem.text) }} 
</template> 

<script>
  import leftMenuItems from '@/utils/leftMenuItems'
  
  let preparedItems = leftMenuItems.reduce((acum, actual) => {
    if (actual.subMenu) {
      acum.push({...actual, level: 1, show: true, subMenuShow: false})
      actual.subMenu.map(submenu => {
        acum.push({...submenu, level: 2, show: false, parentMenu: actual.key, aditionalClass: 'animate-flicker'})
        if (submenu.subMenu) {
          submenu.subMenu.map(submenu2 => {
            acum.push({...submenu2, level: 3, show: false, parentMenu: submenu.key, grandParentMenu: actual.key, aditionalClass: 'animate-flicker'})
          })
        }
      })
    } else {
      let formatedMenu = {...actual, level: 1, show: true, subMenuShow: false}
      acum.push(formatedMenu)
    }
    return acum
  }, [])

  export default {
    name: 'LeftMenu',
    data () {
      return {
        menuItems: preparedItems
      }
    },
    methods: {
      clickMenu(actualMenu) {
        actualMenu.subMenuShow = !actualMenu.subMenuShow
        this.menuItems.forEach(menuItem => {
          if (menuItem.parentMenu === actualMenu.key) {
            if (this.isSamePath(actualMenu.path)) {
              menuItem.show = true
            } else {
              menuItem.show = actualMenu.subMenuShow
              if (!actualMenu.subMenuShow) {
                menuItem.subMenuShow = false
              }
            }
          }
          if (menuItem.grandParentMenu && menuItem.grandParentMenu === actualMenu.key && !actualMenu.subMenuShow) {
            menuItem.show = false
          }
        })
      },
      isSamePath(path) {
        return this.$route.path === path
      },
      redirectToExternalPlace(src) {
        window.open(src)
      }
    },
    mounted () {
    }
  }
</script>
